<template>
    <div>
        <div v-if="label" :class="who === 'split' ? 'pb-5' : 'pb-1'">
            <input-label :label_class="label_class"> {{ $t(label) }}</input-label>
        </div>

        <div class="flex-1 flex flex-col sm:flex-row items-start"
            :class="who === 'split' ? 'mt-4' : ''"
        >
            <input-radio-multi
                :name="field + '[0]'"
                v-model="who"
                :options="types"
                :read_only="read_only"
                :nullable="true"
                @input="changed"
            />

            <div v-if="who === 'split'"
                class="flex flex-1 items-center sm:ml-8 sm:-mt-8"
            >
                <div class="w-1/2 mr-4">
                    <input-percent
                        label="Buyer"
                        :name="field + '[1][buyer]'"
                        v-model="buyer_split"
                    />
                </div>

                <div class="w-1/2">
                    <input-percent
                        label="Seller"
                        :name="field + '[1][seller]'"
                        v-model="seller_split"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        field: {},
        value: {},
        label: {},
        label_class: {},
        read_only: { default: false },
    },

    data() {
        return {
            types: [
                { value: 'buyer', label: 'Buyer' },
                { value: 'seller', label: 'Seller' },
                { value: 'split', label: 'Split' },
            ],
            who: this.value?.[0] || null,
            buyer_split: this.value?.[1]?.buyer || null,
            seller_split: this.value?.[1]?.seller || null,
        }
    },

    methods: {
        changed(value) {
            if (value != 'split') {
                this.buyer_split = null;
                this.seller_split = null;
            }
        },
    },

    watch: {
        value(value) {
            this.$emit('input', value);
        },
    },
}
</script>
